import type { Permission } from '@ztechapps/common.contract'

export const invoicePermissions = {
  canView: {
    value: 'invoice.canView',
    label: 'Can View',
    description: 'No modification can be done to the invoice, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'invoice.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of invoice',
  } satisfies Permission,
}
